"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var LOADING_TEXT = '読み込み中...';
var ERROR_TEXT = '読み込みに失敗しました';
var ChildBrandListMoreController = /** @class */ (function (_super) {
    __extends(ChildBrandListMoreController, _super);
    function ChildBrandListMoreController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ChildBrandListMoreController.prototype, "listEl", {
        get: function () {
            var _a;
            // PC: ul.tax_list / SP: ul inside .child_category_list
            return ((_a = this.element.querySelector('.tax_list')) !== null && _a !== void 0 ? _a : this.element.querySelector('.child_category_list ul'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildBrandListMoreController.prototype, "isSpLayout", {
        get: function () {
            return !this.element.querySelector('.tax_list');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChildBrandListMoreController.prototype, "pcCustomClass", {
        get: function () {
            var _a;
            return (_a = this.element.dataset.pcCustomClass) !== null && _a !== void 0 ? _a : 'wide no_child';
        },
        enumerable: false,
        configurable: true
    });
    ChildBrandListMoreController.prototype.loadMore = function (e) {
        var _this = this;
        e.preventDefault();
        if (!this.hasButtonTarget)
            return;
        var btn = this.buttonTarget;
        var url = btn.getAttribute('data-more-url');
        if (!url)
            return;
        var nextOffset = btn.getAttribute('data-next-offset');
        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = LOADING_TEXT;
        var requestUrl = new URL(url, window.location.origin);
        if (nextOffset)
            requestUrl.searchParams.set('offset', nextOffset);
        fetch(requestUrl.toString(), { method: 'GET', headers: { Accept: 'application/json' } })
            .then(function (res) {
            if (!res.ok)
                throw new Error("HTTP ".concat(res.status));
            return res.json();
        })
            .then(function (data) {
            var isSp = _this.isSpLayout;
            var list = _this.listEl;
            if (!list)
                return;
            data.items.forEach(function (item) {
                var el = isSp ? _this.buildCatItem(item) : _this.buildTaxListCell(item);
                if (!isSp)
                    el.classList.add('tax_list_cell--new');
                list.appendChild(el);
            });
            if (_this.hasCounterTarget) {
                _this.counterTarget.textContent = "1~".concat(data.shown, "/").concat(data.total, "\u4EF6\u8868\u793A\u4E2D");
            }
            if (!data.has_more) {
                btn.style.display = 'none';
            }
            else {
                var currentOffset = parseInt(nextOffset !== null && nextOffset !== void 0 ? nextOffset : '0', 10) || 0;
                btn.setAttribute('data-next-offset', String(currentOffset + data.items.length));
                btn.disabled = false;
                btn.innerHTML = originalHTML;
            }
        })
            .catch(function () {
            btn.disabled = false;
            btn.innerHTML = originalHTML;
            if (_this.hasCounterTarget) {
                _this.counterTarget.textContent = ERROR_TEXT;
            }
        });
    };
    // PC layout: li.tax_list_cell
    ChildBrandListMoreController.prototype.buildTaxListCell = function (item) {
        var li = document.createElement('li');
        li.className = "tax_list_cell ".concat(this.pcCustomClass);
        var a = document.createElement('a');
        a.className = 'title_link';
        a.href = item.link;
        var taxonomy = document.createElement('div');
        taxonomy.className = "taxonomy hover_bg category".concat(item.category_ids);
        var titleDiv = document.createElement('div');
        titleDiv.className = 'title';
        var icon = document.createElement('i');
        icon.className = "taxonomy icon category".concat(item.category_ids);
        var span = document.createElement('span');
        span.className = 'title_str text_overflow_ellipsis textOverflowEllipsis';
        span.textContent = item.title;
        titleDiv.appendChild(icon);
        titleDiv.appendChild(span);
        a.appendChild(taxonomy);
        a.appendChild(titleDiv);
        li.appendChild(a);
        return li;
    };
    // SP layout: li.cat-item — mirrors _navigation_list.slim structure
    ChildBrandListMoreController.prototype.buildCatItem = function (item) {
        var li = document.createElement('li');
        li.className = 'cat-item cat-item--new';
        li.setAttribute('data-controller', 'tooltip');
        li.setAttribute('data-tooltip-toggle-class', 'cat-item-marker-tooltip-visible');
        var a = document.createElement('a');
        a.href = item.link;
        var wrapper = document.createElement('div');
        wrapper.className = 'cat-item-marker-wrapper';
        wrapper.textContent = item.title;
        a.appendChild(wrapper);
        li.appendChild(a);
        return li;
    };
    ChildBrandListMoreController.targets = ['button', 'counter'];
    return ChildBrandListMoreController;
}(stimulus_1.Controller));
exports.default = ChildBrandListMoreController;
